// Theme: mint-protocol
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'mint-protocol',
  name: 'MINT PROTOCOL',
  tagline: 'MINT PROTOCOL',
  description: 'Protocolo menta com leitura tecnica e tom vegetal refrescante.',
  category: 'system-core',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#0F1A14', '#1A2A1F', '#6EE7B7', '#D1FAE5'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-mint-protocol'
  },
  colorVars: {
    '--accent': '#6EE7B7',
    '--accent-foreground': '#0F1A14',
    '--background': '#0F1A14',
    '--border': '#2A7A5A',
    '--card': '#1A2A1F',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#D1FAE5',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1A14',
    '--foreground': '#D1FAE5',
    '--hold-fill': '#6EE7B7',
    '--input': '#2A7A5A',
    '--modal-bg': '#0F1A14',
    '--modal-border': '#2A7A5A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A7A5A',
    '--muted-foreground': '#D1FAE5',
    '--nav-active': '#6EE7B7',
    '--nav-bg': '#1A2A1F',
    '--popover': '#1A2A1F',
    '--popover-foreground': '#D1FAE5',
    '--primary': '#6EE7B7',
    '--primary-foreground': '#0F1A14',
    '--ring': '#6EE7B7',
    '--secondary': '#2A7A5A',
    '--secondary-foreground': '#D1FAE5',
    '--streak': '#6EE7B7',
    '--success': '#22c55e',
    '--success-foreground': '#0F1A14',
    '--xp': '#6EE7B7',
    '--xp-bg': '#1A2A1F'
  },
  resolvedVars: {
    '--accent': '#6EE7B7',
    '--accent-foreground': '#0F1A14',
    '--accent-foreground-hsl': '147 27% 8%',
    '--accent-foreground-oklch': 'from #0F1A14 l c h',
    '--accent-hsl': '156 72% 67%',
    '--accent-oklch': 'from #6EE7B7 l c h',
    '--background': '#0F1A14',
    '--background-hsl': '147 27% 8%',
    '--background-oklch': 'from #0F1A14 l c h',
    '--border': '#2A7A5A',
    '--border-hsl': '156 49% 32%',
    '--border-oklch': 'from #2A7A5A l c h',
    '--border-w': '1px',
    '--card': '#1A2A1F',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 40%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#D1FAE5',
    '--card-foreground-hsl': '149 80% 90%',
    '--card-foreground-oklch': 'from #D1FAE5 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 6%, transparent)',
    '--card-hsl': '139 24% 13%',
    '--card-oklch': 'from #1A2A1F l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1A14',
    '--destructive-foreground-hsl': '147 27% 8%',
    '--destructive-foreground-oklch': 'from #0F1A14 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D1FAE5',
    '--foreground-hsl': '149 80% 90%',
    '--foreground-oklch': 'from #D1FAE5 l c h',
    '--hold-fill': '#6EE7B7',
    '--hold-fill-hsl': '156 72% 67%',
    '--hold-fill-oklch': 'from #6EE7B7 l c h',
    '--input': '#2A7A5A',
    '--input-hsl': '156 49% 32%',
    '--input-oklch': 'from #2A7A5A l c h',
    '--modal-bg': '#0F1A14',
    '--modal-bg-hsl': '147 27% 8%',
    '--modal-bg-oklch': 'from #0F1A14 l c h',
    '--modal-border': '#2A7A5A',
    '--modal-border-hsl': '156 49% 32%',
    '--modal-border-oklch': 'from #2A7A5A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A7A5A',
    '--muted-foreground': '#D1FAE5',
    '--muted-foreground-hsl': '149 80% 90%',
    '--muted-foreground-oklch': 'from #D1FAE5 l c h',
    '--muted-hsl': '156 49% 32%',
    '--muted-oklch': 'from #2A7A5A l c h',
    '--nav-active': '#6EE7B7',
    '--nav-active-hsl': '156 72% 67%',
    '--nav-active-oklch': 'from #6EE7B7 l c h',
    '--nav-bg': '#1A2A1F',
    '--nav-bg-hsl': '139 24% 13%',
    '--nav-bg-oklch': 'from #1A2A1F l c h',
    '--popover': '#1A2A1F',
    '--popover-foreground': '#D1FAE5',
    '--popover-foreground-hsl': '149 80% 90%',
    '--popover-foreground-oklch': 'from #D1FAE5 l c h',
    '--popover-hsl': '139 24% 13%',
    '--popover-oklch': 'from #1A2A1F l c h',
    '--primary': '#6EE7B7',
    '--primary-foreground': '#0F1A14',
    '--primary-foreground-hsl': '147 27% 8%',
    '--primary-foreground-oklch': 'from #0F1A14 l c h',
    '--primary-hsl': '156 72% 67%',
    '--primary-oklch': 'from #6EE7B7 l c h',
    '--radius': '10px',
    '--ring': '#6EE7B7',
    '--ring-hsl': '156 72% 67%',
    '--ring-oklch': 'from #6EE7B7 l c h',
    '--secondary': '#2A7A5A',
    '--secondary-foreground': '#D1FAE5',
    '--secondary-foreground-hsl': '149 80% 90%',
    '--secondary-foreground-oklch': 'from #D1FAE5 l c h',
    '--secondary-hsl': '156 49% 32%',
    '--secondary-oklch': 'from #2A7A5A l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#6EE7B7',
    '--streak-hsl': '156 72% 67%',
    '--streak-oklch': 'from #6EE7B7 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F1A14',
    '--success-foreground-hsl': '147 27% 8%',
    '--success-foreground-oklch': 'from #0F1A14 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(156 72% 67% / 0.15)',
    '--xp': '#6EE7B7',
    '--xp-bg': '#1A2A1F',
    '--xp-bg-hsl': '139 24% 13%',
    '--xp-bg-oklch': 'from #1A2A1F l c h',
    '--xp-hsl': '156 72% 67%',
    '--xp-oklch': 'from #6EE7B7 l c h'
  }
}
